"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function User24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "user-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M12,14 C14.7614237,14 17,11.7614237 17,9 C17,6.23857625 14.7614237,4 12,4 C9.23857625,4 7,6.23857625 7,9 C7,11.7614237 9.23857625,14 12,14 Z M12,2 C15.8659932,2 19,5.13400675 19,9 C19,11.4123062 17.7797674,13.5396119 15.9228691,14.79835 C18.9030772,16.0707941 21.1400651,18.7490636 21.7999676,22.0000191 L19.7481308,22.000644 C18.8602692,18.5498628 15.7279108,16 12,16 C8.27208922,16 5.13973081,18.5498628 4.25186923,22.000644 L2.20003235,22.0000191 C2.85993486,18.7490636 5.09692276,16.0707941 8.07765565,14.7985509 C6.22023262,13.5396119 5,11.4123062 5,9 C5,5.13400675 8.13400675,2 12,2 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function User24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(User24Svg, Object.assign({}, svgProps)));
}
exports.default = User24;
//# sourceMappingURL=User24.js.map